var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.79162 0.5C8.10804 0.5 8.36962 0.735008 8.41104 1.04007L8.41679 1.12488L8.41779 7.16667H14.462C14.8072 7.16667 15.087 7.4465 15.087 7.79167C15.087 8.10808 14.8519 8.36958 14.5469 8.411L14.462 8.41667H8.41779L8.41945 14.4576C8.41954 14.8028 8.13979 15.0828 7.79462 15.0828C7.4782 15.0828 7.21662 14.8478 7.1752 14.5427L7.16945 14.4578L7.16779 8.41667H1.12695C0.78177 8.41667 0.501953 8.13683 0.501953 7.79167C0.501953 7.47525 0.737078 7.21375 1.04214 7.17233L1.12695 7.16667H7.16779L7.16679 1.12512C7.1667 0.77995 7.44645 0.5 7.79162 0.5Z",
    fill: "#0358A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.d815fc76deeab0f3a7a333189e5d61be.svg";
export { ForwardRef as ReactComponent };